/** Rechnungs- & E-Rechnungsprofil für Cutier / Ramin Dell (Firebase: cutier_settings/default.invoiceProfile) */
export interface CutierInvoiceProfile {
  /** Aussteller / Firmenname */
  displayName: string;
  accountHolder: string;
  bankName: string;
  iban: string;
  bic: string;
  taxNumber: string;
  vatId: string;
  street: string;
  zip: string;
  city: string;
  country: string;
  email: string;
  phone: string;
  /** Empfänger (CUTIER / Michael Herzinger) */
  buyerCompanyName: string;
  buyerContactPerson: string;
  buyerEmail: string;
  buyerStreet: string;
  buyerZip: string;
  buyerCity: string;
  buyerCountry: string;
  buyerVatId: string;
  defaultPaymentTermsDays: number;
}

/** Vorausfüllung für das Formular — erst nach Speichern in Firebase gültig */
export const CUTIER_INVOICE_PROFILE_TEMPLATE: CutierInvoiceProfile = {
  displayName: 'ramin dell luxury hair',
  accountHolder: 'ramin dell luxury hair',
  bankName: '',
  iban: '',
  bic: '',
  taxNumber: '',
  vatId: '',
  street: 'Hauptstraße 44',
  zip: '65760',
  city: 'Eschborn',
  country: 'DE',
  email: 'rd@ramindell.com',
  phone: '',
  buyerCompanyName: 'CUTIER by Herzinger Schneidepartner GmbH',
  buyerContactPerson: 'Michael Herzinger',
  buyerEmail: 'info@cutier.de',
  buyerStreet: 'Gmunder Str. 35',
  buyerZip: '81379',
  buyerCity: 'München',
  buyerCountry: 'DE',
  buyerVatId: '',
  defaultPaymentTermsDays: 14,
};

export const EMPTY_CUTIER_INVOICE_PROFILE: CutierInvoiceProfile = {
  displayName: '',
  accountHolder: '',
  bankName: '',
  iban: '',
  bic: '',
  taxNumber: '',
  vatId: '',
  street: '',
  zip: '',
  city: '',
  country: 'DE',
  email: '',
  phone: '',
  buyerCompanyName: '',
  buyerContactPerson: '',
  buyerEmail: '',
  buyerStreet: '',
  buyerZip: '',
  buyerCity: '',
  buyerCountry: 'DE',
  buyerVatId: '',
  defaultPaymentTermsDays: 14,
};
